export default "__VITE_ASSET__aDouVYL7__"